import React from 'react';

export function SectionHeading({ icon, title, count }) {
  return (
    <div data-testid={`map-section-${title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 18px 10px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ width: 26, height: 26, borderRadius: 8, background: 'rgba(112, 63, 246, 0.10)', color: 'var(--accent-purple)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>{icon}</span>
        <p style={{ margin: 0, fontFamily: "'Inria Serif', serif", fontSize: 16, fontWeight: 700, color: 'var(--text)', letterSpacing: '-0.005em' }}>{title}</p>
      </div>
      {typeof count === 'number' ? (
        <span style={{ fontFamily: "'Inria Serif', serif", fontSize: 12.5, color: 'var(--text-2)', fontWeight: 600 }}>{count} {count === 1 ? 'venue' : 'venues'}</span>
      ) : null}
    </div>
  );
}
